<template>
  <div class="container">
    <div v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="'modal_' + contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" class="modal justify-content-center fade" v-bind:id="'modal_' + contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" tabindex="-1" aria-labelledby="nombreDelModal" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="nombreDelModal">{{contenidoDeLaPaginaWeb}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <p class="page-text">{{contenidoDeLaPaginaWeb.TextoDelContenido}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    <div class="row tablaDeVinculos">
        <table class="table table-striped table-hover table-bordered mt-4">
            <thead class="head-table">
                 <th class="titulo w-5 text-center" v-if="seccionDeLaPaginaWeb.ConColumnaDeEnumeracion ||seccionDeLaPaginaWeb.ConColumnaDeEnumeracion==null"></th>
                  <th class="titulo text-center" v-for="(titulo, indice) in seccionDeLaPaginaWeb.Titulo.split('¶')" v-bind:key="titulo" :class="{ 'w-10': (indice == (seccionDeLaPaginaWeb.Titulo.split('¶').length - 1)) }">{{titulo}}</th>
            </thead>
            <tbody>
                <tr v-for="(contenidoDeLaPaginaWeb, indice) in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
                     <td class="text-center" v-if="seccionDeLaPaginaWeb.ConColumnaDeEnumeracion ||seccionDeLaPaginaWeb.ConColumnaDeEnumeracion==null">{{(indice + 1)}}</td> 
                    <td class="text-justify">{{contenidoDeLaPaginaWeb.TextoDelContenido}}</td>
                    <td v-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0" class="p-0 text-center align-middle">
                      <div class="h-100 text-center align-middle" v-for="archivoDeContenidoDeLaPaginaWeb in contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb" v-bind:key="archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId">
                        <!-- DESCARGA DE ENLACE -->
                        <a v-if="archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo != 'EsVideo' && archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo != 'EsExterno' && archivoDeContenidoDeLaPaginaWeb.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId == TIPO_ROL_DE_ARCHIVO && !mostrarDocumentoEnVisor(archivoDeContenidoDeLaPaginaWeb)" class="btn btn-default" v-on:click="AbrirDocumento(archivoDeContenidoDeLaPaginaWeb.RutaDeArchivoCarpeta, '_self');">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>           
                        <!-- VISOR DOCUMENTOS -->
                        <a v-if="archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo != 'EsVideo' && archivoDeContenidoDeLaPaginaWeb.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId == TIPO_ROL_DE_ARCHIVO && mostrarDocumentoEnVisor(archivoDeContenidoDeLaPaginaWeb)" @click="mostrarVisor(archivoDeContenidoDeLaPaginaWeb)" class="btn btn-default">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                        <!-- VISOR VIDEO -->
                        <a v-if="archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo == 'EsVideo'" data-toggle="modal" v-bind:data-target="'#modal_' + archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                        <a v-if="archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo == 'EsExterno'" :href="archivoDeContenidoDeLaPaginaWeb.RutaDelArchivo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                        <a v-if="archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo == 'EsExterno'" :href="archivoDeContenidoDeLaPaginaWeb.RutaDelArchivo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                        

<!-- CODIGO DE MODAL-->
             <div  v-bind:key="'modal_' + archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId" class="modal justify-content-center fade" v-bind:id="'modal_' + archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId" tabindex="-1" aria-labelledby="nombreDelModal"  aria-hidden="true">
            <div class="modal-dialog  modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                     <div class="modal-lg" >
                        <video controls :src="archivoDeContenidoDeLaPaginaWeb.RutaDelArchivo" width="100%" height="100%"></video>
                    </div> 
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
<!--FIN CODIGO DE MODAL-->
                      </div>
                    </td>
                    <td v-else class="w-10 text-center align-middle" :class="{ 'p-0': contenidoDeLaPaginaWeb.Vinculo.includes('http') }">
                      <div v-if="contenidoDeLaPaginaWeb.Vinculo.includes('http') || contenidoDeLaPaginaWeb.Vinculo.includes('https')">
                        <a :href="contenidoDeLaPaginaWeb.Vinculo" target="_blank">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>             
                      </div>
                      <router-link v-else :to="contenidoDeLaPaginaWeb.Vinculo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</router-link>
                    </td>   
                </tr>
            </tbody>
        </table>
    </div>
    </div>

</template>

<script>
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import comun from "@/../static/js/comun";

export default {

    data() { 
      return {
        TIPO_ROL_DE_ARCHIVO: 1,
        visor: {
          contRender: 0
        },
        RUTA_LOCAL:' \\\\themisfstest\\Files',
        enumeraciones_sicpo
      }
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        mostrarVisor: function(archivo) {
         // console.log("archivo:::::",archivo)
           this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor',archivo.RutaDeArchivoCarpeta);      
          // this.visor.contRender ++;
          // $("#modal_visor_documentos" + archivoId).modal('show');
        },
        AbrirDocumento: function(vinculo, formaDeApertura) {
         // console.log(vinculo);
          comun.DescargarDocumentoPDF(vinculo);
           // window.open(vinculo, formaDeApertura);
        }, 
        CreaLaClaseDeCol: function(tamanoDeLaColumna) {
            return "col-md-" + tamanoDeLaColumna + " col-" + tamanoDeLaColumna;
        },
        mostrarDocumentoEnVisor: function(archivo) {
          let mostrar = false;
          if(archivo.hasOwnProperty('MostrarEnVisor') && (archivo.MostrarEnVisor != null && archivo.MostrarEnVisor != undefined)) {
            mostrar = archivo.MostrarEnVisor;
          }
          return mostrar;
        },
        obtenerUrlDocumento: function(url) { 
          const UBICACION = '\\\\themisfs\\'
          let urlCompuesta =  url.split('\\');
          urlCompuesta.shift();
          let urlConFormato = urlCompuesta.join('\\');
          return (UBICACION + urlConFormato);
        }
    }
}
</script>

<style scoped>
  .head-table {
    background-color:rgb(0,117,115);
    color:white
   
  }
    [id^="modal_visor_documentos"] .modal-lg {
        max-width: 70% !important;
    }

  [id^="modal_visor_documentos"] .modal-header {
    background-color: rgb(36, 34, 34);
    
    border: none;
    color: white;
  }

    [id^="modal_visor_documentos"] .modal-content {
        background-color: #dee2e6;
    }

  a {
    color: rgb(33,33,33);
    font-weight: 500;
    cursor: pointer;
  }

  .w-5 {
    width: 5% !important;
  }

  .w-10 {
    width: 10% !important;
  }

  .p-0 {
    padding-top: 5px !important;
  }

  .tablaDeVinculos .titulo {
    text-align: center;
    font-size: 1em;
  }

    .tablaDeVinculos table tbody tr td a {
      font-size: 0.9rem;
    }

    .tablaDeVinculos table tbody tr td div a {
      font-size: 0.9rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/TablaConVinculos.vue